module.exports = __webpack_public_path__ + "static/media/014.a69129e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/014.jpg
// module id = 521
// module chunks = 0